<template>
  <SpTableDIY :data-list="[{}]">
    <SpTableColumn label="FirstTitle">
      {{ modelValue.title }}
    </SpTableColumn>
    <SpTableColumn label="ShipName">
      {{ modelValue.name }}
    </SpTableColumn>
    <SpTableColumn label="Flag">
      {{ modelValue.flag }}
    </SpTableColumn>
    <SpTableColumn label="BuiltYear">
      {{ modelValue.builtYear }}
    </SpTableColumn>
    <SpTableColumn label="DWT">
      {{ modelValue.dwt }}
    </SpTableColumn>
  </SpTableDIY>
</template>

<script type="text/ecmascript-6">
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn'
import SpTableDIY from '@/components/common/SpTableDIY/SpTable'
export default {
  name: 'ShipInfoTable',

  nameSpace: 'ShipInfoTable',

  components: {
    SpTableDIY,
    SpTableColumn
  },

  props: {
    modelValue: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data () {
    return {
    }
  },

  computed: {

  },

  created () {
  },

  mounted () {
  },

  methods: {
  }
}
</script>

<style scoped lang="less">
.ShipInfoTable{
  //css、less
}
</style>
